class Events {
  constructor({ id, _id, name, start_date, final_date, country }) {
    this.id = id || _id;
    this.name = name;
    this.start_date = start_date;
    this.final_date = final_date;
    this.country = country;
  }
}

export default Events;